import PocketBase from 'pocketbase';

const pb = new PocketBase('/');

export default pb;
